"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchFieldStyles = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var Theme_1 = require("@atg/icf-react-components/themes/Theme");
var react_jss_1 = require("react-jss");
exports.useSearchFieldStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    keywordField: function (_a) {
        var shouldUseHeaderStyles = _a.shouldUseHeaderStyles;
        return ({
            background: shouldUseHeaderStyles ? theme.colors.baseContrast020 : theme.colors.textOnDark,
            border: shouldUseHeaderStyles ? "none" : "solid 1px ".concat(theme.colors.baseContrast060),
            height: "".concat(shouldUseHeaderStyles ? theme.spacing.base * 6 - theme.spacing.base * 2 : theme.spacing.base * 5, "px"),
            width: shouldUseHeaderStyles ? "320px" : "100%",
            flex: "none",
            position: "relative",
            zIndex: 100,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            boxSizing: "border-box",
            borderRadius: "2px",
        });
    },
    textInput: function (_a) {
        var color = _a.color;
        return ({
            boxSizing: "border-box",
            background: "none",
            padding: "8px",
            height: "inherit",
            fontSize: "14px",
            appearance: "none",
            outline: "0px",
            color: color,
            borderWidth: "0px",
            borderStyle: "solid",
            borderRadius: "0px",
            borderColor: "rgb(189, 189, 189)",
            width: "100%",
        });
    },
    button: {
        border: "10px",
        boxSizing: "border-box",
        display: "inline-block",
        cursor: "pointer",
        textDecoration: "none",
        margin: 0,
        marginInlineEnd: theme.spacing.base * 2,
        padding: 0,
        outline: "none",
        fontSize: 0,
        fontWeight: "inherit",
        position: "relative",
        overflow: "visible",
        transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
        width: "48px",
        height: "inherit",
        textAlign: theme.direction === Theme_1.Direction.rtl ? "left" : "right",
        background: "none",
    },
}); });
//# sourceMappingURL=SearchField.js.map